<template>
  <div class="max-w-[1200px] mx-auto pt-6 pb-12">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-lg font-normal">Blog</h1>
      <button
        class="text-sm font-normal text-gray-900 bg-white border border-gray-300 rounded-md px-3 py-1 hover:bg-gray-50"
        type="button"
      >
        Ajouter un Blog
      </button>
    </div>

    <!-- Liste des blogs -->
    <div class="grid grid-cols-3 gap-4">
      <div
        v-for="blog in blogs"
        :key="blog.id"
        class="flex flex-col rounded-lg border border-gray-300 overflow-hidden shadow-sm"
      >
        <img
          class="object-cover w-full h-40"
          :src="blog.image"
          alt="Blog image"
        >
        <div class="p-4 flex flex-col flex-1">
          <h1 class="text-lg font-semibold mb-2">{{ blog.title }}</h1>
          <p class="text-gray-600 mb-4">{{ blog.description }}</p>
          <button
            @click="editBlog(blog.id)"
            class="mt-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Modifier
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

// Tableau des blogs
const blogs = [
  {
    id: 1,
    title: 'Blog numero 1',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6vJkbAWVHg_H9haoeG7xjnne2yUKEJBDOcQ&s'
  },
  {
    id: 2,
    title: 'Blog numero 2',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6vJkbAWVHg_H9haoeG7xjnne2yUKEJBDOcQ&s'
  },
  {
    id: 3,
    title: 'Blog numero 3',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6vJkbAWVHg_H9haoeG7xjnne2yUKEJBDOcQ&s'
  }
]

// Fonction pour rediriger vers la page de modification
function editBlog(id) {
  router.push(`/blog/${id}`)
}
</script>
